import 'twin.macro';
import _isEmpty from 'lodash-es/isEmpty';
import { v4 as uuid } from 'uuid';
import { PlusSmallIcon as PlusSm } from '@heroicons/react/24/outline';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { useCreateLivretCompetence } from '@teetsh/app/src/containers/Livrets/queries/competences/useCreateLivretCompetence';
import {
  AutoSuggest,
  Option,
} from '@teetsh/app/src/components/Form/AutoSuggest';
import Textarea from '@teetsh/app/src/components/Form/Textarea';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  livretEvalId: string;
  livretEleveId: string;
  domaineId?: string;
  matiereId: string;
  options: Option[];
}

export function AddCompetenceButton(props: Props) {
  const { livretEvalId, livretEleveId, domaineId, matiereId } = props;
  const [isEditing, setIsEditing] = useState(false);
  const [value, onChange] = useState('');
  const { t } = useTranslation(['common']);
  const createCompetence = useCreateLivretCompetence({
    livretEvalId,
    livretEleveId,
  });
  if (isEditing) {
    return (
      <AutoSuggest
        options={props.options}
        portal
        autoFocus
        onChange={v => {
          onChange(v);
        }}
        onBlur={v => {
          if (_isEmpty(v)) {
            setIsEditing(false);
            return;
          }

          return createCompetence({
            domaineId,
            matiereId,
            id: uuid(),
            name: v,
          }).then(() => setIsEditing(false));
        }}
        Component={Textarea}
        offset={8}
        value={value}
      />
    );
  }
  return (
    <Button
      minimal
      small
      fill
      tw="text-muted"
      aria-label="Ajouter une compétence"
      onClick={() => setIsEditing(true)}
      icon={PlusSm}
    >
      {t('common:buttons.add')}
    </Button>
  );
}
